// extracted by mini-css-extract-plugin
export default {"text":"ReadMore_text__Vp+hb","read-or-hide":"ReadMore_read-or-hide__GYUBE"};